export const hoverlist = [
  {
    label: 'None',
    value: '',
  },
  {
    label: 'Hover Box',
    value: 'box'
  },
  {
    label: 'Hover Medium Box',
    value: 'box-medium'
  },
  {
    label: 'Rotate -1deg when hover',
    value: 'ani-rotate',
  },
  {
    label: 'Translate up 5px when hover',
    value: 'ani-translate-up',
  },  
]
